import React from "react";
import { useState } from "react";
import {Link} from "react-router-dom";
import './Footer.css'
import logo from "../images/logo.png"
function Footer (){
    const [email,setEmail]=useState(""); 
    const changeEmail = (e)=>{
        setEmail(e.target.value)
    }

    return(
        <footer>
            <div className="container">
                <div className="row">
                    <div className="col-md-3 col-sm-6">
                        <div className="logo">
                            <img src={logo}/>
                            <h2> D-Clinic</h2>
                        </div>
                        <p>is a modern medical website that helps patients easily book appointments online with doctors across various specialties.</p>
                        <div className="footer-contact">
                            <div className="footer-icon">
                                <i className="fa-solid fa-phone"></i>
                            </div>
                            <div className="footer-text">
                                <h6>contact us</h6>
                                <h5>+(20) 1016407214</h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                        <h2>Quick Links</h2>
                        <ul>
                            <li><Link to="/about">About Us</Link></li>
                            <li><Link to="/service">Services</Link></li>
                            <li><Link to="/booking">Booking</Link></li>
                            <li><Link to="/error">Error 404</Link></li>
                            <li><Link href="/blog">Blogs</Link></li>
                            <li><Link href="/blog">Our Team</Link></li>
                        </ul>
                    </div>
                    <div className="col-md-3 col-sm-6">
                        <h2>Our Service</h2>
                        <ul>
                            <li><Link to="/service">Dental Care</Link></li>
                            <li><Link to="/service">Cardiac Clinic</Link></li>
                            <li><Link to="/service">Massage Therapy</Link></li>
                            <li><Link to="/service">Cardiology</Link></li>
                            <li><Link to="/service">Precise Diangosis</Link></li>
                            <li><Link to="/service">Ambulance Service</Link></li>
                        </ul>
                    </div>
                    <div className="col-md-3 col-sm-6">
                        <h2>Subscribe</h2>
                        <form>
                            <input placeholder="Your Email" type="email" onChange={changeEmail} value={email} required/>
                            <button className="btn" type="submit">Subscribe Now</button>
                        </form>
                        <div className="social-links">
                            <ul>
                                <li><a href="#"><i className="fa-brands fa-instagram"></i></a></li>
                                <li><a href="#"><i className="fa-brands fa-facebook"></i></a></li>
                                <li><a href="#"><i className="fa-brands fa-x-twitter"></i></a></li>
                                <li><a href="#"><i className="fa-brands fa-linkedin"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="end">
                <p>
                     copy right @ 2025 / Developed By Eng/Omar Mahmoud
                </p>
            </div>
        </footer>



    )
}

export default Footer;
